import { AxiosError } from 'axios';
import { AccountingErrorResponse } from 'multirpc-sdk';

export const getAccountingErrorCode = (
  error: AxiosError<AccountingErrorResponse>,
) => error.response?.data.error.code;
